(function($) {
  var kompetanseModalInitialized = false;

  function KompetanseModal(elem) {

    this.buttonTarget = elem;
    this.overlay = null;
    this.active = false;

    this.xhr = null;

    this.data = {
      ajaxUrl: elem.data('ajax-url')
    };

    this.init();
  }

  KompetanseModal.prototype.init = function() {

    this.createOverlay();
    this.createModal();
    this.addEventListeners();
  }

  KompetanseModal.prototype.addEventListeners = function() {

    var app = this;

    this.buttonTarget.on('click', function(e) {
      e.preventDefault();
      app.hide();
      app.show();
    });

    this.buttonCloseTarget.on('click', function() {
      app.hide();
    });

    $(document).on('click', function(e)  {
      if (app.overlay.is(e.target)) {
        app.hide();
      }
    });

    $(document).keyup( function(e) {
      if (e.keyCode === 27) {
        app.hide();
      }
    });

    if (kompetanseModalInitialized === false) {
      $(window).resize( function() {
        app.fit();
      });
    }

    kompetanseModalInitialized = true;
  }

  KompetanseModal.prototype.fit = function () {

    this.modal.css({ height: 'auto' });

    var paddingVertical = parseInt( this.modalWrapper.css('padding-top') ) + parseInt( this.modalWrapper.css('padding-bottom') );
    var paddingHorizontal = parseInt( this.modalWrapper.css('padding-left') ) + parseInt( this.modalWrapper.css('padding-right') );
    var windowHeight = $(window).height();
    var windowWidth = $(window).width();
    var newHeight = windowHeight - paddingVertical;

    if (this.modalWrapper.hasClass('show')) {
      var self = this
      setTimeout(function () {
        var modalContentHeight = self.modal.find('.kb-modal-content').height()
        var initialHeight = modalContentHeight + parseInt( self.modal.css('padding-top') ) + parseInt( self.modal.css('padding-bottom') );
        if (initialHeight > newHeight) {
          initialHeight = newHeight
        }
        self.modal.css({ height: initialHeight });
      }, 200)
    }
    var modalHeight = this.modal.height();

    this.modal.css({width: windowWidth - paddingHorizontal});

    if ((modalHeight + paddingVertical) > newHeight) {
      this.modal.css({
        height: newHeight
      });
    }
  }

  KompetanseModal.prototype.setContent = function(content) {
    this.modalContentTarget.html(content);
    window.vc_js();
  }

  KompetanseModal.prototype.toggle = function() {
    if (this.active === true) {
      this.hide();
    } else {
      this.show();
    }
  }

  KompetanseModal.prototype.showLoader = function() {
    this.modal.attr('class',  'animated fadeOut kb-modal');
    this.overlay.addClass('kb-loader');
  }

  KompetanseModal.prototype.hideLoader = function() {
    this.overlay.removeClass('kb-loader');
  }

  KompetanseModal.prototype.ajaxRequest = function(obj, cb) {
    var app = this;

    this.showLoader();

    obj.success = function(response) {
      if ( response.html ) {
        app.setContent( response.html );
        app.showModal();
        app.hideLoader();

              // var startCourseBtn = $("#sfwd-mark-complete");
              // if(startCourseBtn) {
              //     startCourseBtn.insertAfter($(".course_link_button"));
              // }

              app.modalContentTarget.find('.kb-modal-link').kbModal();

              if (typeof cb === 'function') {
                cb();
              }

              this.xhr = null;
            }
          }

          this.xhr = $.ajax(obj)
        }

        KompetanseModal.prototype.show = function() {

          this.active = true;

          $('body').addClass('kb-modal-open');

          this.overlay.attr('class', 'fadeIn animated kb-overlay show');

          if ( this.data.ajaxUrl ) {
            this.ajaxRequest({url: this.data.ajaxUrl});
          } else {
            this.showModal();
          }
        }


        KompetanseModal.prototype.showModal = function() {
          this.hideLoader();
          this.modalWrapper.addClass('show');
          this.modal.attr('class',  'animated fadeIn kb-modal');
          this.buttonTarget.trigger('showModal', [this]);

          this.fit();
        }

        KompetanseModal.prototype.hide = function() {

          var app = this;

          if (this.active == false) {
            return;
          }

          if (this.xhr) {
            this.xhr.abort();
          }

          clearInterval(this.wrapperInterval);

          $('body').removeClass('kb-modal-open');

          app.buttonTarget.trigger('beforeHideModal', [this]);
          this.overlay.attr('class', 'fadeOut animated kb-overlay');
          this.modal.attr('class',  'animated fadeOut kb-modal');

          this.wrapperInterval = setTimeout(function() {
            app.active = false;
            app.modalWrapper.find('iframe').remove();
            app.modalWrapper.removeClass('show');
          }, 1000);
        }

        KompetanseModal.prototype.createModal = function() {

          if ( $('.kb-modal-wrapper').length <= 0 ) {
            this.modalWrapper = $('<div class="kb-modal-wrapper"></div>');
            this.modal = $('<div class="kb-modal"></div>');
            this.buttonCloseTarget = $('<button class="kb-modal-close"><span></span></button>');
            this.modalContentTarget = $('<div class="kb-modal-content"></div>');

            this.modalWrapper.append(this.modal);
            this.modal.append(this.buttonCloseTarget);
            this.modal.append(this.modalContentTarget);

            $('body').append(this.modalWrapper);
          } else {
            this.modalWrapper = $('.kb-modal-wrapper');
            this.modal = $('.kb-modal-wrapper .kb-modal');
            this.buttonCloseTarget = $('.kb-modal-wrapper .kb-modal-close');
            this.modalContentTarget = $('.kb-modal-wrapper .kb-modal-content');
          }

          this.fit();
        }

        KompetanseModal.prototype.createOverlay = function() {

          if ($('.kb-overlay').length <= 0) {
            this.overlay = $('<div class="kb-overlay"></div>');
            $('body').append(this.overlay);
          } else {
            this.overlay = $('.kb-overlay');
          }
        }

        function KompetanseModalLearnDash(target) {

          this.target = target;

          this.init();
        }

        KompetanseModalLearnDash.prototype.init = function () {

          var app = this;

          this.target.kbModal();
          this.modal = null;

          var completedCourses = $.cookie('learndash-completed-courses');
          if (completedCourses) {
            var objCompletedCourses = JSON.parse(completedCourses);
            for ( var idCourse in objCompletedCourses ) {
              var idsPosts = objCompletedCourses[idCourse];
              for ( var key = 0; key < idsPosts.length; key++ ) {
                this.markAsCompleteHTML(idsPosts[key], idCourse);
              }
            }
          }

          this.target.on('showModal', function (event, modal) {
            app.modal = modal;
            app.addEventListeners(modal);
          });

          this.target.on('beforeHideModal', function (event, modal) {
            app.modal = modal;
            app.removeEventListeners(modal);
          });
        }

        KompetanseModalLearnDash.prototype.removeEventListeners = function() {

          this.modal.modalContentTarget.find('.next-link').off('click', this.courseNext);
          this.modal.modalContentTarget.find('.prev-link').off('click', this.coursePrev);
          this.modal.modalContentTarget.find('.finish-link').off('click', this.finishCurrent);
        }

        KompetanseModalLearnDash.prototype.addEventListeners = function() {

          this.modal.modalContentTarget.find('.next-link').on('click', $.proxy(this, 'courseNext'));
          this.modal.modalContentTarget.find('.prev-link').on('click', $.proxy(this, 'coursePrev'));
          this.modal.modalContentTarget.find('.finish-link').on('click', $.proxy(this, 'finishCurrent'));
        }

        KompetanseModalLearnDash.prototype.finishCurrent = function() {
          event.preventDefault();
          var app = this;
          var idPost = $(event.currentTarget).data('post-id');
          var idCourse = $(event.currentTarget).data('course-id');

          app.modal.showLoader();

          $.ajax({
            method: 'POST',
            url: kb_script.ajax_url,
            data: {
              id_post: idPost,
              id_course: idCourse,
              action: 'mark_as_complete'
            },
            success: function() {
              app.markAsComplete(idPost, idCourse);
              app.modal.hide();
            }
          });
        }

        KompetanseModalLearnDash.prototype.coursePrev = function(event) {
          event.preventDefault();
          this.modal.ajaxRequest({
            url: kb_script.ajax_url,
            method: 'GET',
            data: {
              id_module: $(event.currentTarget).data('id-module'),
              action: 'get_module_course'
            }
          });
        }

        KompetanseModalLearnDash.prototype.courseNext = function(event) {
          event.preventDefault();
          var app = this;
          var idNextModule = $(event.currentTarget).data('next-id');
          var idPost = $(event.currentTarget).data('post-id');
          var idCourse = $(event.currentTarget).data('course-id');

          this.modal.showLoader();
          this.modal.ajaxRequest({
            url: kb_script.ajax_url,
            method: 'POST',
            data: {
              id_next_module: idNextModule,
              id_post: idPost,
              id_course: idCourse,
              action: 'get_next_module_course'
            }
          }, function () {
            app.markAsComplete(idPost, idCourse);
          });
        }

        KompetanseModalLearnDash.prototype.markAsComplete = function(idPost, idCourse) {
          this.markAsCompleteHTML(idPost, idCourse);
          this.markAsCompleteCookie(idPost, idCourse);
        }

        KompetanseModalLearnDash.prototype.markAsCompleteCookie = function(idPost, idCourse) {
          var completedCourses = $.cookie('learndash-completed-courses');
          var jsonCompletedCourses = {};
          if (completedCourses) {
            jsonCompletedCourses = JSON.parse(completedCourses);
          }
          if (typeof jsonCompletedCourses[idCourse] === 'undefined') {
            jsonCompletedCourses[idCourse] = [];
          }
          jsonCompletedCourses[idCourse].push(idPost);

          $.cookie('learndash-completed-courses', JSON.stringify(jsonCompletedCourses), {path: '/'});
        }

        KompetanseModalLearnDash.prototype.markAsCompleteHTML = function(idPost, idCourse) {
          var item = $('#learndash_post_' + idCourse + ' ' + '.post-' + idPost + ' .kb-modal, #learndash_post_' + idCourse + ' ' + '#post-' + idPost + ' .kb-modal');

          item.removeClass('notcompleted');
          item.addClass('completed');
        }

        window.jQuery.fn.extend({
          kbModal: function() {
            this.each(function() {
              new KompetanseModal(jQuery(this));
            });
          },
          kbLearnDashModal: function () {
            this.each(function () {
              new KompetanseModalLearnDash(jQuery(this));
            })
          }
        });

  //jQuery('.kb-modal').kbModal();
  jQuery('.kb-modal').kbLearnDashModal();
  jQuery('.kb-learn-dash-modal').kbLearnDashModal();

})(jQuery);

jQuery(document).ready(function($){

  // function get_parameters_by_object(url){
  //   var search = url.search.substring(1);
  //   return JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}', function(key, value) { return key===""?value:decodeURIComponent(value) });
  // }

  // function add_parameter_as_suffix_to_links(){
  //   var params = get_parameters_by_object(window.location);
  //   var region = params.o;
  //   var links = $('a');
  //   links.each(function(){
  //     var href = $(this).attr('href');
  //     var isLink = href.includes('http');
  //     var hasParameters = href.includes('?');
  //     if(isLink && !hasParameters) {
  //       $(this).attr('href', href + '?o='+region);
  //     }
  //   })
    
  // }
  // add_parameter_as_suffix_to_links();


  // add_parameter_as_suffix_to_links();

  // $('body').imagesLoaded( function() {
  //     $( window ).resize(function() {
  //         if( $(window).width() >= 768 ) {
  //             $('.equal-height').equalHeights();
  //             $('.course-height').equalHeights();
  //         }
  //     });

  //     if( $(window).width() >= 768 ) {
  //         $('.equal-height').equalHeights();
  //         $('.course-height').equalHeights();
  //     }
  // });

  // Script to find overflow element
 /*  var docWidth = document.documentElement.offsetWidth;
  [].forEach.call(
    document.querySelectorAll('*'),
    function(el) {
      if (el.offsetWidth > docWidth) {
        console.log(el);
      }
    }
  ); */

  // Add selected area to helsefellesskap link
  const $samhandlingLink = $(".samhandling-link");
  const urlParams = new URLSearchParams(window.location.search);
  const locationSelected = urlParams.get('o');

  if($samhandlingLink) {
    if(locationSelected) {
      $samhandlingLink.find("a").attr("href", "/helsefellesskap-" + locationSelected);
    } else {
      $samhandlingLink.hide();
    }
  }

  // Add current menu item class to helsefellesskapside
  const $samhandlingsSideMenuItem = $('#site-header li.samhandling-link');

  if(window.location.href.indexOf("helsefellesskap-") != -1) {
    $samhandlingsSideMenuItem.addClass("active"); 
  }

  // Show menu when scrolling up
  let scrollTop;
  $(document).scroll(function() {
    if(window.scrollY > 0) { 
      if(window.scrollY < scrollTop) {
        if(window.scrollY > 97) {
          $(".header-fixed").addClass("sticky-show");
        } else {
          $(".header-fixed").removeClass("sticky");
        }
      } else {
        
        if(window.scrollY > 97) {
          $(".header-fixed").addClass("sticky");
        } 
        $(".header-fixed").removeClass("sticky-show"); 
      }
    } else {
      $(".header-fixed").removeClass("sticky");
      $(".header-fixed").removeClass("sticky-show");
    }
    scrollTop = window.scrollY; 
  })

  // Add current menu item class to legesiden
  const $legeSideMenuItem = $('#site-header li.legesiden-link');
  
  if(window.location.href.indexOf("leger-") != -1) {
    $legeSideMenuItem.addClass("active"); 
  }

  // open submenu if current page is a child item
  const $childPageOpen = $('#site-header li.current_page_ancestor');
  
  if($childPageOpen.length > 0) {
    $("#site-header li.menu-item-has-children > a").addClass("open");
    $("#site-header li.menu-item-has-children > a").parents("li.menu-item-has-children").addClass("open");
    $("#site-header li.menu-item-has-children > a").parents("li.menu-item-has-children").find("ul").slideDown();
  }

  // Open sub menu
  $("#site-header li.menu-item-has-children > a").click(function(e) {
    const $this = $(this);
    e.preventDefault();

    $this.toggleClass("open");
    $this.parents("li.menu-item-has-children").toggleClass("open");

    if($this.hasClass("open")) {
      $this.parents("li.menu-item-has-children").find("ul").slideDown();
    } else {
      $this.parents("li.menu-item-has-children").find("ul").slideUp();
    }
  })

  // Hover sectors oslo 
  const $sectorsSection = $(".sectors-oslo");
  if($sectorsSection.length > 0) {
    const $sectorTextRed = $(".red-text");
    const $sectorTextLightRed = $(".light-red-text");
    const $sectorTextYellow = $(".yellow-text");
    const $sectorTextBlack = $(".black-text");
    const $sectorSvgRed = $(".red-svg");
    const $sectorSvgLightRed = $(".light-red-svg");
    const $sectorSvgYellow = $(".yellow-svg");
    const $sectorSvgBlack = $(".black-svg");
    $(".sectors-oslo a.light-red").hover(function() {
      $sectorTextLightRed.addClass("active");
      $sectorSvgLightRed.addClass("show");
      $(this).siblings("path.red-red-outline").addClass("active");
    }, function() {
        $(this).siblings("path.red-red-outline").removeClass("active");
        $sectorTextLightRed.removeClass("active");
        $sectorSvgLightRed.removeClass("show");
    });
    $(".sectors-oslo a.yellow").hover(function() {
      $sectorTextYellow.addClass("active");
      $sectorSvgYellow.addClass("show");
      $(this).siblings("path.yellow-black-outline").addClass("active");
    }, function() {
        $(this).siblings("path.yellow-black-outline").removeClass("active");
        $sectorTextYellow.removeClass("active");
        $sectorSvgYellow.removeClass("show");
    });
    $(".sectors-oslo a.red").hover(function() {
      $sectorTextRed.addClass("active");
      $sectorSvgRed.addClass("show");
      $(this).siblings("path.red-black-outline").addClass("active");
    }, function() {
        $(this).siblings("path.red-black-outline").removeClass("active");
        $sectorTextRed.removeClass("active");
        $sectorSvgRed.removeClass("show");
    });
    $(".sectors-oslo a.black").hover(function() {
      $sectorTextBlack.addClass("active");
      $sectorSvgBlack.addClass("show");
      $(this).siblings("path.black-red-outline").addClass("active");
    }, function() {
        $(this).siblings("path.black-red-outline").removeClass("active");
        $sectorTextBlack.removeClass("active");
        $sectorSvgBlack.removeClass("show");
    });
    $(".svg-text-wrapper-light-red").hover(function() {
      $sectorTextLightRed.addClass("active");
      $sectorSvgLightRed.addClass("show");
      $("path.red-red-outline").addClass("active");
    }, function() {
        $("path.red-red-outline").removeClass("active");
        $sectorTextLightRed.removeClass("active");
        $sectorSvgLightRed.removeClass("show");
    });
    $(".svg-text-wrapper-yellow").hover(function() {
      $sectorTextYellow.addClass("active");
      $sectorSvgYellow.addClass("show");
      $("path.yellow-black-outline").addClass("active");
    }, function() {
        $("path.yellow-black-outline").removeClass("active");
        $sectorTextYellow.removeClass("active");
        $sectorSvgYellow.removeClass("show");
    });
    $(".svg-text-wrapper-red").hover(function() {
      $sectorTextRed.addClass("active");
      $sectorSvgRed.addClass("show");
      $("path.red-black-outline").addClass("active");
    }, function() {
        $("path.red-black-outline").removeClass("active");
        $sectorTextRed.removeClass("active");
        $sectorSvgRed.removeClass("show");
    });
    $(".svg-text-wrapper-black").hover(function() {
      $sectorTextBlack.addClass("active");
      $sectorSvgBlack.addClass("show");
      $("path.black-red-outline").addClass("active");
    }, function() {
        $("path.black-red-outline").removeClass("active");
        $sectorTextBlack.removeClass("active");
        $sectorSvgBlack.removeClass("show");
    });
  }

  // Move area selector
  function moveAreaSelector() {
    const $areaContainer = $(".area-select-btn").clone();
    $areaContainer.insertBefore($(".area-selector-modal__close"));
  }
  moveAreaSelector();
  $('.area-selector-link').click(function(e) {
    e.preventDefault();
    $(this).closest('.area-select-btn').toggleClass('area-selector-open')

    //$('.area-selector-modal__wrapper').removeClass("show");
  });

  // Open/close menu
  const $menuName = $("#menu-toggle").find("span:last-of-type").text();
  $(document).on('click', '#menu-toggle', function(e) {
    e.preventDefault();
    $(this).toggleClass("open");
    const $menunameElement = $(this).find("span:last-of-type");
    
    if($('#topmenu-wrapper').hasClass("main-menu-open")) {
      $('#site-header').slideToggle(function() {
        $('#topmenu-wrapper').removeClass("main-menu-open");
        $('.search-box-container').removeClass("display");
        $('#topmenu-wrapper #logo').css("opacity", "1");
        $('body').removeClass("noscroll");
      });
      $menunameElement.text($menuName);
    } else {
      $('#site-header').slideToggle();
      $('#topmenu-wrapper').addClass("main-menu-open");
      $('body').addClass("noscroll");
      $('#topmenu-wrapper #logo').css("opacity", "0");
      $('.search-box-container').addClass("display");
      $menunameElement.text("Lukk");
    }
  });

  /*$(document).on('click', '.mobile-menu .menu-item-has-children > a', function(e){
      //e.stopPropagation();
      e.preventDefault();
      //$('.sub-menu').not($(this).siblings('.sub-menu')).slideUp();
      //$(this).siblings('.sub-menu').slideToggle();
      return false;
    });*/

    $(".woo-toggle-event-box").click(function(e) {
      var $box = $(this).closest('.woo-event-list-header').next('.woo-event-list-wrapper');

      if($(this).hasClass('active')) {
        $box.removeClass('open');
        $(this).removeClass('active');
      } else {
        $(this).addClass('active');
        $box.addClass('open');
      }
      return false;
    });

    $(".toggle-event-box").click(function(e) {
      var $this = $(this);
      var $box = $("#" +$this.attr('data-box'));

      if($this.hasClass('active')) {
        $this.removeClass('active');
        $box.removeClass('open');
      } else {
        $this.addClass('active');
        $box.addClass('open');
      }
      return false;
    });

    $(".mobile-menu .menu-item-has-children > a").click(function(e) {
      e.preventDefault();
      $('.sub-menu').not($(this).siblings('.sub-menu')).slideUp();
      $(this).siblings('.sub-menu').slideToggle();
      return false;
    });

  /*$('.grid').masonry({
      columnWidth: '.grid-sizer',
      itemSelector: '.grid-item',
      percentPosition: true
    });*/

    var $search = $('#searchfield');
  // var widgetSearch = $search.autocomplete({}).data('ui-autocomplete');

  // $search.autocomplete({
  //     source: ajaxurl + '?action=site_search',
  //     minLength: 3,
  //     appendTo: "#search-results",
  //     focus: function( event, ui ) {
  //         var value = ui.item.value;
  //         var newVal = value.replace('<strong>', '');
  //         newVal = newVal.replace('</strong>', '');
  //         ui.item.value = newVal;
  //     },
  //     select: function(event, ui) {
  //         top.location.href = ui.item.url;
  //         return false;
  //     }
  // });

  // widgetSearch._renderItem = function( ul, item ) {
  //     if(item.noresults) {
  //         var listitem = item.message;
  //         return $('<li class="noresultitem">').append(listitem).appendTo(ul);
  //     } else {
  //         if(item.searchurl) {
  //             var listitem = '<a class="button secondary" href="' + item.searchurl + '">' + item.text + ' (' + item.total + ')</a>';
  //             return $('<li class="showall">').append(listitem).appendTo(ul);
  //         } else {
  //             var listitem = '<a class="result" href="' + item.url + '"><span>' + item.value + '<em>' + item.label + '</em></span></a>';
  //             return $("<li>").append(listitem).appendTo(ul);
  //         }
  //     }
  // };

  $search.keypress(function (e) {
    if (e.which == 13) {
      top.location.href='/?s=' + encodeURIComponent($(this).val());
    }
  });

  $(document).on( 'click', '.siteman-film-container .play', function () {
    var provider = $(this).parent().attr('data-provider');
    var id = $(this).parent().attr('data-src');
    var f;
    if( $(this).parents('.wpse-content_wrapper').length ) {
      $(this).parents('.wpse-content_wrapper').addClass('active-film');
    }
    if( provider == "YouTube" ) {
      f = $('<iframe allowfullscreen />').attr('src', 'https://www.youtube.com/embed/'+id+'?autoplay=1&autohide=1&border=1&wmode=opaque&enablejsapi=1&fs=1');
      $(this).parent().empty().append(f);
    } else if( provider == "Vimeo" ) {
      f = $('<iframe allowfullscreen />').attr('src', 'https://player.vimeo.com/video/'+id+'?title=0&byline=0&portrait=0&badge=0');
      $(this).parent().empty().append(f);
    }
  });
  $(".theme-menu").click(function(e) {
  //$(document).on( 'click', '.primary-nav .theme-menu', function (e) {
    e.preventDefault();
    if( $('#library-main-wrapper').is(':visible') )
      $('#library-main-wrapper').slideUp();
    $('#theme-main-wrapper').slideToggle();
    return false;
  });

  $(".library-menu").click(function(e) {
  //$(document).on( 'click', '.library-menu', function (e) {
    e.preventDefault();
    if( $('#theme-main-wrapper').is(':visible') )
      $('#theme-main-wrapper').slideUp();
    $('#library-main-wrapper').slideToggle();

    return false;
  });
  $(document).on( 'click', '.close-menu', function() {$(this).parents('.sub-menu-wrapper').slideToggle() });

  $("#espresso-thank-you-page-overview-dv .ee-button").attr('target', '_blank');

  $("#toggle-mobile-filter").click(function() {
    if($(this).parents("body.category").length > 0) {
      if($(this).find("span").text().trim() == 'Vis filter') {
        $(this).find("span").text('Skjul filter');
        $(this).find("svg.vertical-line").addClass("show");
      } else {
        $(this).find("span").text('Vis filter');
        $(this).find("svg.vertical-line").removeClass("show");
      }
    } else {
      if($(this).find("span").text().trim() == 'Vis filter') {
        $(this).find("span").text('Skjul filter');
        $(this).find("svg.vertical-line").addClass("show");
      } else {
        $(this).find("span").text('Vis filter');
        $(this).find("svg.vertical-line").removeClass("show");
      }
    }
    $("#toggle-mobile-filter-content").slideToggle(400);
  });

  var startCourseBtn = $("#sfwd-mark-complete");
  if(startCourseBtn) {
    startCourseBtn.insertAfter($(".course_link_button"));
  }

  // Hack for setting inputfields for fname, lname and email as readonly
  $(".ee-reg-form-attendee-dv .ee-reg-qstn-fname").attr('readonly', 'readonly');
  $(".ee-reg-form-attendee-dv .ee-reg-qstn-lname").attr('readonly', 'readonly');
  $(".ee-reg-form-attendee-dv .ee-reg-qstn-email").attr('readonly', 'readonly');

  // if ( $('.vc_kompetanse-container-accordion').length > 0 ) {
  //     $('.vc_kompetanse-container-accordion').each(function(){
  //
  //         $(this).accordion({
  //             header: '.vc_kopetanse-panel-heading'
  //         });
  //
  //     });
  // }

  $('.js-lang-add-to-cart input.qty').on( 'keyup', function(){
    var $button = $(this).closest('.js-lang-add-to-cart').find('button[name="add-to-cart"]');
    var langPular = $button.data('lang-pular');
    var singlePular = $button.data('lang-single');
    var value = parseInt( $(this).val() );
    if ( value > 1 ) {
      $button.text(langPular);
    } else {
      $button.text(singlePular);
    }
  } );

  $(document).on('change', '#iv_billing_customer_type', function(e) {
    var selectedCustomerType = $(this).val();
    var sveaNumbersLinksContainer = $('#svea-bussines-numbers-link-container');
    if (selectedCustomerType === 'company') {
      sveaNumbersLinksContainer.show();
    } else {
      sveaNumbersLinksContainer.hide()
    }
  });

  var lastPosition = $(window).scrollTop();

  window.onscroll = function(ev) {

    var windowWidth = $(window).width();
    var scrollPosition = $(window).scrollTop();

    if ( windowWidth < 991 && window.innerHeight < window.innerWidth ) {

      var scrollEnd = $(document).height() - $(window).height() - 50;
      var scrollStart = 50;

      if ( lastPosition < scrollPosition &&
        ( scrollEnd > scrollPosition ||
          scrollStart < scrollPosition ) ) {
        $('#content').addClass('hide-sticky-header');
      $('.header-fixed').addClass('hide-sticky-header');
    } else {
      $('#content').removeClass('hide-sticky-header');
      $('.header-fixed').removeClass('hide-sticky-header');
    }
  }

  lastPosition = scrollPosition;
};

$('a:not(.vc_tta-tab) [href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function (event) {
          // On-page links
          if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            &&
            location.hostname == this.hostname
            ) {
              // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
              // Does a scroll target exist?
              if (target.length) {
                  // Only prevent default if animation is actually gonna happen
                  event.preventDefault();
                  $('html, body').animate({
                    scrollTop: target.offset().top
                  }, 1000, function() {
                      // Callback after animation
                      // Must change focus!
                      var $target = $(target);
                      $target.focus();
                      if ($target.is(":focus")) { // Checking if the target was focused
                        return false;
                      } else {
                          $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                          $target.focus(); // Set focus again
                        };
                      });
                }
              }
            });

  if (window.location.pathname == '/min-side/mine-kurs/') {
    $('.hide-in-aranger-page').css('display', 'none');
  }

});

jQuery(function ($) {
  var post_id  ;
  var user_id  ;
  const addFavorite = (post_id , user_id) => {
  $.ajax({
      url: fk_script.ajaxUrl,
      type: 'POST',
      data: {
          action: 'add_to_favorite',   
          post_id,
          user_id
      },
      }).done((response) => {
        var post_id =null;
    })  
  };  
const removeFavorite = (post_id , user_id) => {
  $.ajax({
      url: fk_script.ajaxUrl,
      type: 'POST',
      data: {
          action: 'remove_from_favorite',   
          post_id,
          user_id
      },
      }).done((response) => {
        var post_id = null;
    })  
  }; 

  $("a.favourites-button").click(function(e){
    e.preventDefault();
      let post_id = $(this).data("post");
      let  user_id = $(this).data("user");
    if($(this).find('svg.unselected-heart').hasClass('active') ) {
      $(this).find('svg.unselected-heart').removeClass('active');
      $(this).find('svg.selected-heart').addClass('active');
      $(this).find('span').html('Favorittmarkert');
      addFavorite(post_id, user_id );
    }
  else {
    $(this).find('svg.unselected-heart').addClass('active');
    $(this).find('svg.selected-heart').removeClass('active');
    $(this).find('span').html('Legg til favoritt');
    removeFavorite(post_id, user_id );
  }
 }); 

 const $warningPopup = $(".warning-popup");
 if($warningPopup.length > 0) {
  $(".warning-popup div.popup-close-button").click(function(e){
    e.preventDefault();
    $warningPopup.addClass("hide"); 
    localStorage.setItem("hide_warning_popup", true);
  }); 
  if(localStorage.getItem("hide_warning_popup")) {
    $warningPopup.addClass("hide");
  } else {
    $warningPopup.removeClass("hide");
  }
 }
 
 $('.my-favourites-table button').click(function(e){
  let post_id = $(this).data("post");
  let  user_id = $(this).data("user");
  removeFavorite(post_id, user_id );
  $(this).parents('tr').remove();
 });

 $('.my-favourites-table input[type="checkbox"]').click(function() {
  let $inputs = $('.my-favourites-table input[type="checkbox"]');
  let selected = [];
  $.each($inputs, function(index, input) {
    if(input.checked) {
      let postID = input.getAttribute('data-post');
      selected.push(parseInt(postID));
    }
  });
  if(selected.length == 0) {
    $.each($inputs, function(index, input) {
        let postID = input.getAttribute('data-post');
        selected.push(parseInt(postID));
    });
  }
 })

 $('.send-list form').submit(function(e) {
  e.preventDefault();
  let $form = $(e.target);
  let formData = $form.serializeArray();
  let $inputs = $('.my-favourites-table input[type="checkbox"]');
  let selected = [];
  $.each($inputs, function(index, input) {
    if(input.checked) {
      let postID = input.getAttribute('data-post');
      selected.push(parseInt(postID));
    }
  });
  if(selected.length == 0) {
    $.each($inputs, function(index, input) {
        let postID = input.getAttribute('data-post');
        selected.push(parseInt(postID));
    });
  }

  let data = new FormData();
  data.append('action', 'submit_favourite_list');
  data.append('selected', selected);

  for (let i = 0; i < formData.length; i++) {
      let name = formData[i]['name'];
      let value = formData[i]['value'];
      data.append(name, value);
  }

  let $response = $form.find('.response');
  $response.hide();
  $response.removeClass('success error');

  $('.send-list form button[type="submit"]').addClass('wait');

  $.ajax({
    url: fk_script.ajaxUrl,    
    type: 'POST',
    data : data,
    cache: false,
    processData: false,
    contentType: false,
    success: function(response) {
        var json = JSON.parse(response);
        var message = json['message'];

        if (json.status === 'success') {
            $response.addClass('success');
        } else {
            $response.addClass('error');
        }

        $response.text(message);
        $response.show();

        $form[0].reset();

        $('.send-list form button[type="submit"]').removeClass('wait');
    },
    error: function(response) {
        console.log(response.responseText);
        $response.html(response.responseText);
        $response.addClass('error');
        $response.show();
    }
  });
 });

  let $gravityForms = $('.gform_wrapper form');
  if($gravityForms.length > 0) {
    $gravityForms.each(function(index, form) {
      let dateInputs = form.querySelectorAll('.gfield--type-date');
      dateInputs.forEach(function(input) {
        input.querySelector('.gform-datepicker').addEventListener('click', function(e) {
          let element = document.querySelector('#ui-datepicker-div');
          element.style.marginTop = '40px';
        });
        input.querySelector('.gform-datepicker').addEventListener('focus', function(e) {
          let element = document.querySelector('#ui-datepicker-div');
          element.style.marginTop = '40px';
        });
      });
    });
  }

});